import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { SecuritiesSelectedComponent } from '@helios/generic-components'
import { BasePanelComponent, LayoutContainer } from '@helios/panel-base'
import { RootState, selectFirstFocusedAccount } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { ComponentContainer } from 'golden-layout'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { SecurityWebComponentKey } from '../panel-key'

@Component({
  selector: 'hs-security-web-component',
  templateUrl: './security-web-component-panel.component.html',
  styleUrls: ['./security-web-component-panel.component.scss'],
})
export class SecurityWebComponentPanelComponent
  extends BasePanelComponent
  implements OnInit, OnDestroy
{
  panelKey = SecurityWebComponentKey
  securityId?: number
  accountId?: number
  private readonly destroy$ = new Subject<void>()
  @ViewChild('securitiesSelectedComponent')
  readonly securitiesSelectedComponent!: SecuritiesSelectedComponent
  /** @internal */
  onSecuritySelectionChanged(securities: number[]) {
    this.securityId = securities[0]
  }
  constructor(
    @Inject(LayoutContainer) container: ComponentContainer,
    private readonly store: Store<RootState>,
  ) {
    super(container)
  }

  ngOnInit(): void {
    this.store
      .select(selectFirstFocusedAccount)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (accountId: number | undefined) => (this.accountId = accountId),
      )
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
